import React from 'react';
import {
    MuiPickersUtilsProvider,
    KeyboardDateTimePicker,
} from '@material-ui/pickers';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

const theme = createTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#CD9E32',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
        secondary: {
          main: '#CD9E32'
        }
      },
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#CD9E32'
            }
        },
        MuiPickersClock: {
            pin: {
                backgroundColor: "#CD9E32"
            },
        },
        MuiPickersClockPointer: {
            thumb: {
                border: '14px solid #CD9E32'
            },
            pointer: {
                backgroundColor: "#CD9E32"
            },
            noPoint: {
                backgroundColor: "#CD9E32"
            },
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                color: "white"
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: "#CD9E32",
                '&:hover': {
                    backgroundColor: '#6c4f00'
                },
            },
        },
        MuiPickerDTTabs: {
            tabs: {
                backgroundColor: "#CD9E32"
            }
        },
        MuiPickersYear: {
            yearSelected: {
                color: '#CD9E32'
            }
        },
        /* MuiFormLabel: {
            '&:focus': {
                color: '#CD9E32'
            },
        }, */
        /* '&.MuiFormLabel': {
            '&:focus': {
                color: '#CD9E32'
            },
            '&.Mui-focused': {
                color: '#CD9E32'
            }
        }, */
        /* '&.Mui-focused': {
            color: '#CD9E32'
        }
        ,
        '&.MuiInput-underline:after': {
            borderBottomColor: '#CD9E32'
        },
        div: {
            '&::after': {
                borderBottomColor: '#CD9E32'
            }
        },
        "& label.Mui-focused": {
            color: '#CD9E32'
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: '#CD9E32'
          }, */
    }
});
const RenderDatePicker = props => {
    const { label, date, onDateChange, id, meta: { touched, error } } = props


    const addDays = (date, days) => {
        const dateCopy = new Date(date);
        dateCopy.setDate(date.getDate() + days);
        return dateCopy;
    }
    const date1 = new Date();

    const handleCut = e => {
        e.preventDefault();
    };

    return (
        <ThemeProvider theme={theme}>
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale} >
                    <KeyboardDateTimePicker
                        autoOk
                        style={{ marginTop: '0px' }}
                        variant="inline"
                        format="yyyy-MM-dd HH:mm"
                        margin="normal"
                        fullWidth
                        id={id}
                        name={id}
                        label={label}
                        value={date}
                        onChange={onDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        minDate={new Date()}
                        maxDate={addDays(date1, 7)}
                        minDateMessage="La fecha no puede ser anterior a la actual"
                        maxDateMessage="La fecha  no puede ser  7 días superior a la actual"
                        onCut={handleCut}
                        inputProps={{
                            readOnly: true,
                        }}
                    />
                </MuiPickersUtilsProvider>
                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
            </div>
        </ThemeProvider>
    );
};

RenderDatePicker.propTypes = {
    // date: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired,
};

export default RenderDatePicker;